import { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";

import { useRoleClientSelection } from "../contexts/RoleClientSelectionContext";
import { resolveRoute } from "../utils/routeHelpers";

export function useRoleClientNavigate() {
  const navigate = useNavigate();
  const { selectedRole, selectedClient } = useRoleClientSelection();

  const resolver = useMemo(() => {
    return (route) =>
      resolveRoute(route, {
        role: selectedRole,
        client: selectedClient,
      });
  }, [selectedRole, selectedClient]);

  return useCallback(
    (routeOrOptions) => {
      if (typeof routeOrOptions === "string") {
        // If it's just a string route, resolve it
        navigate(resolver(routeOrOptions));
      } else {
        // If it's an object with route/options
        const { route, ...options } = routeOrOptions;
        navigate(resolver(route), options);
      }
    },
    [navigate, resolver],
  );
}
